import MatchingPricingCard from './MatchingPricingCard.component';

export default MatchingPricingCard;